/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_WorkoutInputs */

const en_onboarding_listen_go_workout = /** @type {(inputs: Onboarding_Listen_Go_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working out or exercising`)
};

const es_onboarding_listen_go_workout = /** @type {(inputs: Onboarding_Listen_Go_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haciendo ejercicio o entrenando`)
};

/**
* | output |
* | --- |
* | "Working out or exercising" |
*
* @param {Onboarding_Listen_Go_WorkoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_workout = /** @type {((inputs?: Onboarding_Listen_Go_WorkoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_WorkoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_workout(inputs)
	return en_onboarding_listen_go_workout(inputs)
});